__turbopack_context__.v({
  "content": "rectangleAd-module-scss-module__vKQLbG__content",
  "desc": "rectangleAd-module-scss-module__vKQLbG__desc",
  "label": "rectangleAd-module-scss-module__vKQLbG__label",
  "link": "rectangleAd-module-scss-module__vKQLbG__link",
});
